module.exports = __webpack_public_path__ + "static/img/wx.53afcad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx.jpg
// module id = rZOy
// module chunks = 27